module.exports = __webpack_public_path__ + "static/media/zepfFranks48.4332ce93.png";